import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const ChevronRightIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
    >
      <g>
        <path d='M9.29 6.71a.996.996 0 0 0 0 1.41L13.17 12l-3.88 3.88a.996.996 0 1 0 1.41 1.41l4.59-4.59a.996.996 0 0 0 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01Z' />
      </g>
    </svg>
  )
);
